import React, { FC } from 'react'
import LayoutConnector, { ConnectorProps as LayoutProps } from './connectors/Layout'
import List from './components/List'
import Detail from './components/Detail'

const ShowsLayout: FC<LayoutProps> = (props) => {
  const { isDetailPage } = props
  return isDetailPage ? <Detail /> : <List />
}

export default LayoutConnector(ShowsLayout)
